import { BoomGateArrowUpOutlineIcon } from './BoomGateArrowUpOutlineIcon';

/**
 * author: Michael Richins
 * id 24E7CECC-7FAC-4FE4-8EAE-B727489040E8
 * name boom-gate-arrow-up-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-arrow-up-outline.svg
 * tags
 * - Transportation + Road 
 */
export const BoomArmUpOutlineIcon = BoomGateArrowUpOutlineIcon;
export default BoomArmUpOutlineIcon